var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner",class:{light:_vm.light}},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }